import { dora, metricsSection } from '@/content/site'

import { Reveal } from './shared/Reveal'
import { SplitTitle } from './shared/SplitTitle'

/** Relative bar widths — illustrative of the Elite→High gap, not real data. */
const BAR = [0.92, 0.78, 0.95, 0.86]

export function MetricsSection() {
  return (
    <section id="metrics" className="border-t border-hairline py-16 md:py-24">
      <div className="shell">
        <Reveal>
          <p className="eyebrow">{metricsSection.eyebrow}</p>
        </Reveal>

        <h2 className="max-w-2xl font-sans text-[1.6rem] md:text-[2.15rem] font-bold tracking-[-0.02em] leading-[1.16]">
          <SplitTitle text={metricsSection.title} />
        </h2>

        <Reveal i={1}>
          <p className="mt-5 max-w-[46rem] text-[0.95rem] md:text-[1.05rem] leading-[1.75] text-ink-dim">
            {metricsSection.intro}
          </p>
        </Reveal>

        <div className="mt-10 grid grid-cols-1 gap-px overflow-hidden rounded-lg border border-hairline bg-hairline sm:grid-cols-2 lg:grid-cols-4">
          {dora.map((metric, i) => (
            <Reveal key={metric.name} i={i} className="h-full">
              <article className="flex h-full flex-col bg-bg p-5 md:p-6">
                <h3 className="font-sans text-sm font-bold tracking-tight md:text-base">
                  {metric.name}
                </h3>
                <p className="mt-1 font-paragraph text-xs leading-relaxed text-ink-mute">
                  {metric.question}
                </p>

                {/* Pure CSS meter — no charting library. */}
                <div className="mt-4 h-1 w-full overflow-hidden rounded-full bg-hairline">
                  <div
                    className="h-full rounded-full bg-accent"
                    style={{ width: `${BAR[i] * 100}%` }}
                  />
                </div>

                <dl className="mt-4 space-y-2">
                  <div className="flex items-baseline justify-between gap-3">
                    <dt className="font-mono text-[0.63rem] uppercase tracking-[0.18em] text-node-output">
                      {metricsSection.eliteLabel}
                    </dt>
                    <dd className="font-mono text-xs tabular-nums text-ink">{metric.elite}</dd>
                  </div>
                  <div className="flex items-baseline justify-between gap-3">
                    <dt className="font-mono text-[0.63rem] uppercase tracking-[0.18em] text-ink-mute">
                      {metricsSection.highLabel}
                    </dt>
                    <dd className="font-mono text-xs tabular-nums text-ink-dim">{metric.high}</dd>
                  </div>
                </dl>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal i={2}>
          <p className="mt-5 font-mono text-[0.63rem] uppercase tracking-[0.18em] text-ink-mute">
            {metricsSection.footnote}
          </p>
        </Reveal>
      </div>
    </section>
  )
}
